import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import classNames from 'classnames';

import Link from '../../components/WrappedLink';

const MenuItem = (props) => {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (!pathname.includes(props.path) && props.path) {
      setMenuOpen(false);
    }
  }, [pathname, props.path]);

  const { title, path, children } = props;

  const wrapperClass = classNames({
    'menu-item-has-children': children,
  });
  const linkClass = classNames({
    selected: menuOpen,
  });
  const subLinkClass = classNames('menu-list-child', {
    active: menuOpen,
    disabled: !menuOpen,
  });

  return (
    <li key={title} className={wrapperClass}>
      <Link
        className={linkClass}
        to={!children ? path : '#'}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {title}
      </Link>
      {children && <ul className={subLinkClass}>{children}</ul>}
    </li>
  );
};

export default MenuItem;
